// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

// 处理重复跳转路由 NavigationDuplicated 报错
const originalPush = router.constructor.prototype.push
router.constructor.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 只屏蔽重复导航错误，其余错误正常抛出
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js